export default __webpack_public_path__ + "static/media/login-page-image.6ae98c92.jpg";